import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { observer } from 'mobx-react';
import * as React from 'react';
import { stylesheet } from "typestyle";
import { Logger, SensorType } from './Models';

const css = stylesheet({
	container: {
		display: 'flex',
		flexDirection: 'column',
		padding: '10px',
	},
	root: {
		height: 'initial',
		width: 'initial',
	},
	settings: {
		opacity: .5,
	},
	textField: {
		width: '200px',
	},
})

@observer
export default class PHLoggerSettings extends React.Component<{
	logger: Logger,
}>{

	state = {
		anchorEl: null,
		pin: '',
		calibrating: false,
		calibrationMessage: '',
	};

	handleClick = (event: React.FormEvent) => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleCalibrate400 = () => {
		this.handleCalibrate(4.0);
	};
	handleCalibrate686 = () => {
		this.handleCalibrate(6.86);
	};
	handleCalibrate918 = () => {
		this.handleCalibrate(9.18);
	};

	handleCalibrate = (calibrationPoint: number) => {
		this.setState({
			calibrating: true,
			calibrationMessage: '',
		});
		this.props.logger.calibrate(this.state.pin, SensorType.PH, calibrationPoint)
			.then(() => {
				this.setState({
					calibrating: false,
					calibrationMessage: 'Success :)',
				});
				setTimeout(() => {
					this.setState({ calibrationMessage: '' })
				}, 800)
			})
			.catch(() => {
				this.setState({
					calibrating: false,
					calibrationMessage: 'Calibration failed, try again',
				});
			})
	};

	handleClose = () => {
		this.setState({
			anchorEl: null,
		});
	};

	handlePinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			pin: event.target.value,
		});
	};

	render() {
		const { anchorEl, calibrating, calibrationMessage } = this.state;

		return (
			<div>
				<IconButton
					className={css.root}
					aria-haspopup="true"
					onClick={this.handleClick}>
					<MoreVertIcon className={css.settings} />
				</IconButton>

				<Popover
					open={Boolean(anchorEl)}
					anchorEl={anchorEl}
					onClose={this.handleClose}
					anchorOrigin={{
						horizontal: 'left',
						vertical: 'top',
					}}
					transformOrigin={{
						horizontal: 'left',
						vertical: 'top',
					}}
				>
					<div className={css.container}>
						<TextField
							id="password-input"
							label="PIN"
							className={css.textField}
							type="password"
							autoComplete="current-password"
							margin="normal"
							onChange={this.handlePinChange}
						/>
						<div>{calibrationMessage}</div>
						<Button disabled={calibrating} onClick={this.handleCalibrate400}>
							Calibrate 4.00
						</Button>
						<Button disabled={calibrating} onClick={this.handleCalibrate686}>
							Calibrate 6.86
						</Button>
						<Button disabled={calibrating} onClick={this.handleCalibrate918}>
							Calibrate 9.18
						</Button>
					</div>
				</Popover>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/PHLoggerSettings.tsx